import { Dispatch } from 'redux';
import { replace } from 'connected-next-router';
import { IgetValidChangeProductsRes } from './types';
import { getQueryString } from '@/Framework/Router';

interface IisRedirectToDefaultActive extends IgetValidChangeProductsRes {
  dispatch: Dispatch,
}

export const isRedirectToDefaultActive = ({
  pathname,
  validProducts,
  validRegions,
  productsChanged,
  regionsChanged,
  dispatch,
}: IisRedirectToDefaultActive): boolean => {
  let shouldRedirect = false;

  if (productsChanged || regionsChanged) {
    shouldRedirect = true;
  }

  if (shouldRedirect) {
    const search = getQueryString({ products: validProducts, regions: validRegions });
    dispatch(replace(`${ pathname }?${ search }`));
  }

  return shouldRedirect;
};
